import script from "./detailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./detailPage.vue?vue&type=script&setup=true&lang=js"

import "./detailPage.vue?vue&type=style&index=0&id=406e1c29&scoped=true&lang=css"

import exportComponent from "/Users/hou/Desktop/zijie/sdxlxh_user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-406e1c29"]])

export default __exports__